import { render, staticRenderFns } from "./base-checkbox-group.vue?vue&type=template&id=645bcc9d"
import script from "./base-checkbox-group.ts?vue&type=script&lang=ts&external"
export * from "./base-checkbox-group.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645bcc9d')) {
      api.createRecord('645bcc9d', component.options)
    } else {
      api.reload('645bcc9d', component.options)
    }
    module.hot.accept("./base-checkbox-group.vue?vue&type=template&id=645bcc9d", function () {
      api.rerender('645bcc9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/CheckboxGroup/base-checkbox-group.vue"
export default component.exports